import { useState, useEffect } from 'react';

import { SplashScreen } from 'src/components/loading-screen';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';

import { useAuthStore } from '../store/auth.store';

type Props = {
  children: React.ReactNode;
};

export default function AuthGuard({ children }: Props) {
  const router = useRouter();
  const { isAuthenticated, isLoading } = useAuthStore();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    // Só faz a verificação DEPOIS que o loading terminar
    if (!isLoading) {
      if (!isAuthenticated) {
        router.replace(paths.auth.login);
      } else {
        setChecked(true);
      }
    }
  }, [isAuthenticated, isLoading, router]);

  if (isLoading) {
    return <SplashScreen />;
  }

  if (!checked) {
    return null;
  }

  return <>{children}</>;
}
